import { createReducer } from 'redux-create-reducer';
import {
  RIBBON_DISSMISSED,
} from '../messages';
import * as r from 'ramda';

export const initialState = {
  dismissed: false,
};

export default createReducer(initialState, {
  [RIBBON_DISSMISSED]: (state) => r.pipe(
    r.assoc('dismissed', true),
  )(state),
});


// WEBPACK FOOTER //
// ./src/domain/reducers/ribbon.js